<template>
  <div>
    <DxDataGrid
      v-if="historicalPrices.length > 0"
      id="historicalPricesGrid"
      :data-source="historicalPrices"
      :column-min-width="70"
      :column-auto-width="true"
      :allow-column-reordering="true"
      :show-borders="true"
      :show-column-lines="true"
      :show-row-lines="true"
      :row-alternation-enabled="true"
      :on-row-updating="updateCropsData"
      @exporting="onExporting"
    >
      <DxHeaderFilter :visible="true" />
      <DxEditing
        :allow-updating="true"
        mode="cell"
      />
      <DxStateStoring
        :enabled="true"
        type="localStorage"
        storage-key="DxCropsHistoricalPrices"
      />
      <DxExport
        :enabled="true"
      />
      <DxPaging :page-size="10" />
      <DxSearchPanel
        :visible="false"
      />
      <DxColumn
        :data-field="$t('Crop')"
        :name="$t('Crop')"
        :allow-header-filtering="true"
        :allow-editing="false"
        :css-class="'bold'"
      />
      <DxColumn
        v-for="item in getYears"
        :key="item"
        :data-field="item"
        :name="item"
        :allow-header-filtering="false"
        :allow-editing="true"
      >
        <DxRequiredRule :message="$t('Required_message')" />
      </DxColumn>
    </DxDataGrid>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import {
  DxDataGrid,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxEditing,
  DxColumn,
  DxStateStoring,
  DxRequiredRule,
  DxHeaderFilter,
} from 'devextreme-vue/data-grid';
import EventBus from '../../js/event-bus';

export default {
  name: 'DxCropsHistoricalPrices',
  components: {
    DxDataGrid,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxEditing,
    DxColumn,
    DxStateStoring,
    DxRequiredRule,
    DxHeaderFilter,
  },
  props: {
    cropsData: {
      type: Object,
      default: () => {},
    },
    currentCrops: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localCropsData: [],
      historicalPrices: [],
    };
  },
  computed: {
    getYears() {
      const years = [];
      for (const key in this.historicalPrices[0]) {
        if (Object.hasOwnProperty.call(this.historicalPrices[0], key)) {
          if (key !== this.$t('Crop')) {
            years.push(key);
          }
        }
      }
      return years;
    },
  },
  mounted() {
    this.localCropsData = this.cropsData;
    this.calculateHistoricalPrices();
    EventBus.$on('cropsSelectorValueChanged', () => this.calculateHistoricalPrices());
  },
  methods: {
    calculateHistoricalPrices() {
      const historicalPrices = [];
      for (const currentCrop of this.currentCrops) {
        if (typeof this.cropsData[currentCrop] !== 'undefined') {
          const historicalPrice = {};
          const historicalPriceSubproduct = {};
          historicalPrice[this.$t('Crop')] = currentCrop;
          historicalPriceSubproduct[this.$t('Crop')] = `${currentCrop} ${this.$t('subproduct')}`;
          for (const key in this.cropsData[currentCrop].economicalData) {
            if (Object.hasOwnProperty.call(this.cropsData[currentCrop].economicalData, key)) {
              const economicalData = this.cropsData[currentCrop].economicalData[key];
              historicalPrice[key] = economicalData.productSellingPrice;
              historicalPriceSubproduct[key] = economicalData.subproductSellingPrice;
            }
          }
          historicalPrices.push(historicalPrice);
          historicalPrices.push(historicalPriceSubproduct);
        }
      }
      this.historicalPrices = historicalPrices;
    },
    onExporting(e) {
      this.$helpers.onExporting(e, 'HistoricalPrices', 'CropsHistoricalPrices.xlsx');
    },
    async updateCropsData(e) {
      const rows = await e.component.getDataSource().items();
      for (const currentCrop of this.currentCrops) {
        const economicalData = {};
        const productSellingPrice = this.getRowByCrop(rows, currentCrop);
        const subproductSellingPrice = this.getRowByCrop(rows, `${currentCrop} ${this.$t('subproduct')}`);
        for (const key in productSellingPrice) {
          if (Object.hasOwnProperty.call(productSellingPrice, key) && (key !== this.$t('Crop'))) {
            economicalData[key] = {
              productSellingPrice: productSellingPrice[key],
              subproductSellingPrice: subproductSellingPrice[key],
            };
          }
        }
        this.localCropsData[currentCrop].economicalData = economicalData;
      }
      this.setCropsData(this.localCropsData);
    },
    getRowByCrop(rows, cropID) {
      for (const row of rows) {
        if (cropID === row[this.$t('Crop')]) return row;
      }
      return [];
    },
    ...mapActions('Mopeco', ['setCropsData']),
  },
};
</script>
<style>
.bold {
  font-weight: bold;
}
</style>
